/**
 * IntelliGems A/B Test: Wall of Love (social proof)
 *
 * Control (A): data-wall-of-love="false"
 * Variant (B): data-wall-of-love="true"
 *
 * Desktop: 4 images per slide (2 slides)
 * Mobile: 1 image per slide
 *
 * Dev preview: ?wall_of_love_test=b
 */
(function () {
  'use strict';

  if (window.__wallOfLoveABTestInit) return;
  window.__wallOfLoveABTestInit = true;

  var BODY_ATTR = 'data-wall-of-love';
  var MOBILE_MQ = '(max-width: 749px)';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('wall_of_love_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return body.getAttribute(BODY_ATTR) === 'true' ||
      html.getAttribute(BODY_ATTR) === 'true';
  }

  function initCarousels(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('[data-wall-of-love-carousel]');

    for (var i = 0; i < carousels.length; i++) {
      setupCarousel(carousels[i]);
    }
  }

  function setupCarousel(root) {
    if (!root) return;

    // Re-init safe: wipe previous listeners by cloning if already ready
    if (root.getAttribute('data-wall-of-love-ready') === 'true') {
      if (root._wolTeardown) root._wolTeardown();
    }

    var track = root.querySelector('[data-wall-of-love-track]');
    var viewport = root.querySelector('.wall-of-love-ab__viewport');
    var items = root.querySelectorAll('[data-wall-of-love-item]');
    var prevBtn = root.querySelector('[data-wall-of-love-prev]');
    var nextBtn = root.querySelector('[data-wall-of-love-next]');
    var dotsWrap = root.querySelector('[data-wall-of-love-dots]');

    if (!track || !viewport || items.length === 0) return;

    root.setAttribute('data-wall-of-love-ready', 'true');

    var desktopPerView = parseInt(root.getAttribute('data-desktop-per-view'), 10) || 4;
    var mobilePerView = parseInt(root.getAttribute('data-mobile-per-view'), 10) || 1;
    var index = 0;
    var totalPages = 1;
    var mq = window.matchMedia(MOBILE_MQ);
    var listeners = [];

    function on(el, type, fn, opts) {
      if (!el) return;
      el.addEventListener(type, fn, opts);
      listeners.push({ el: el, type: type, fn: fn, opts: opts });
    }

    function getPerView() {
      return mq.matches ? mobilePerView : desktopPerView;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalPages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wall-of-love-ab__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('data-wall-of-love-dot', String(i));
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === index) btn.setAttribute('aria-current', 'true');
        dotsWrap.appendChild(btn);
      }
    }

    function updateChrome() {
      var hideNav = totalPages <= 1;
      if (prevBtn) prevBtn.hidden = hideNav;
      if (nextBtn) nextBtn.hidden = hideNav;
      if (dotsWrap) dotsWrap.hidden = hideNav;
    }

    function centerNav() {
      var stage = root.querySelector('.wall-of-love-ab__stage') || viewport.parentElement;
      var h = viewport ? viewport.offsetHeight : 0;
      if (!h && stage) h = stage.offsetHeight;
      if (!h) return;
      var topPx = Math.round(h / 2) + 'px';
      if (prevBtn) {
        prevBtn.style.top = topPx;
        prevBtn.style.transform = 'translateY(-50%)';
      }
      if (nextBtn) {
        nextBtn.style.top = topPx;
        nextBtn.style.transform = 'translateY(-50%)';
      }
    }

    function goTo(nextIndex) {
      if (totalPages <= 0) return;
      index = ((nextIndex % totalPages) + totalPages) % totalPages;
      // Pixel offset vs viewport — % translateX is relative to the track width
      var offset = index * viewport.offsetWidth;
      track.style.transform = 'translateX(-' + offset + 'px)';

      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('[data-wall-of-love-dot]');
        for (var d = 0; d < dots.length; d++) {
          dots[d].classList.toggle('is-active', d === index);
          dots[d].setAttribute('aria-current', d === index ? 'true' : 'false');
        }
      }
      centerNav();
    }

    function recalc() {
      var perView = getPerView();
      totalPages = Math.max(1, Math.ceil(items.length / perView));
      if (index >= totalPages) index = totalPages - 1;
      buildDots();
      updateChrome();
      goTo(index);
      centerNav();
    }

    function onResize() {
      goTo(index);
      centerNav();
    }

    function onPrev() {
      goTo(index - 1);
    }

    function onNext() {
      goTo(index + 1);
    }

    function onDotsClick(event) {
      var target = event.target.closest('[data-wall-of-love-dot]');
      if (!target) return;
      var dotIndex = parseInt(target.getAttribute('data-wall-of-love-dot'), 10);
      if (!isNaN(dotIndex)) goTo(dotIndex);
    }

    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    function onTouchStart(event) {
      if (!event.touches || !event.touches.length) return;
      dragging = true;
      startX = event.touches[0].clientX;
      deltaX = 0;
    }

    function onTouchMove(event) {
      if (!dragging || !event.touches || !event.touches.length) return;
      deltaX = event.touches[0].clientX - startX;
    }

    function onTouchEnd() {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(deltaX) > 40) {
        goTo(deltaX > 0 ? index - 1 : index + 1);
      }
      deltaX = 0;
    }

    on(prevBtn, 'click', onPrev);
    on(nextBtn, 'click', onNext);
    on(dotsWrap, 'click', onDotsClick);
    on(track, 'touchstart', onTouchStart, { passive: true });
    on(track, 'touchmove', onTouchMove, { passive: true });
    on(track, 'touchend', onTouchEnd);
    on(window, 'resize', onResize);

    // Re-center after images load (height: auto)
    var imgs = root.querySelectorAll('.wall-of-love-ab__img');
    for (var ii = 0; ii < imgs.length; ii++) {
      if (imgs[ii].complete) continue;
      on(imgs[ii], 'load', centerNav);
    }
    if (typeof ResizeObserver !== 'undefined' && viewport) {
      var ro = new ResizeObserver(function () { centerNav(); });
      ro.observe(viewport);
      root._wolResizeObserver = ro;
    }

    function onMqChange() {
      recalc();
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMqChange);
      listeners.push({ el: mq, type: 'change', fn: onMqChange, opts: undefined, isMq: true });
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onMqChange);
      listeners.push({ el: mq, type: 'change', fn: onMqChange, opts: undefined, isMq: true, legacy: true });
    }

    root._wolTeardown = function () {
      if (root._wolResizeObserver) {
        root._wolResizeObserver.disconnect();
        root._wolResizeObserver = null;
      }
      for (var i = 0; i < listeners.length; i++) {
        var L = listeners[i];
        if (L.isMq) {
          if (L.legacy && typeof L.el.removeListener === 'function') {
            L.el.removeListener(L.fn);
          } else if (typeof L.el.removeEventListener === 'function') {
            L.el.removeEventListener(L.type, L.fn);
          }
        } else {
          L.el.removeEventListener(L.type, L.fn, L.opts);
        }
      }
      listeners = [];
      root.removeAttribute('data-wall-of-love-ready');
      root._wolTeardown = null;
    };

    recalc();
    centerNav();
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      if (variantB === variantActive) {
        if (variantB) initCarousels();
        return;
      }

      variantActive = variantB;
      document.documentElement.classList.toggle('wall-of-love-b', variantB);

      if (variantB) {
        initCarousels();
      }
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    initCarousels();
    applyVariant();

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    document.addEventListener('gem:variant:changed', scheduleApply);

    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      if (event.target.querySelector && event.target.querySelector('[data-wall-of-love-carousel]')) {
        initCarousels(event.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
